import Shopify from '../utils/Shopify'
// import { getProductBySlug, getPage } from '../../content.js'

const shopify = new Shopify()

export default
{
    props:
    {
        product: { type: Object },
        color: { type: String, default: 'green' }
    },

    watch:
    {
        color(color)
        {
            this.colorOpposite = color === 'green' ? 'sand' : 'green'
        }
    },
    
    data()
    {
        return {
            addHidden: false,
            num: 0,
            colorOpposite: 'sand'
        }
    },

    created()
    {
        shopify.getCart(this.updateNum)
        shopify.onCartUpdated.add(this.updateNum)
    },

    mounted()
    {
        this.colorOpposite = this.color === 'green' ? 'sand' : 'green'
    },

    destroyed()
    {
        shopify.onCartUpdated.remove(this.updateNum)
    },

    methods:
    {
        add(quantity, itemSlug, oldQuantity = null)
        {
            shopify.getProductBySlug(itemSlug, product =>
            {
                const variantId = product.variants[0].id
                if (quantity > 0)
                {
                    shopify.addItemsToCart(variantId, quantity)
                }
                else
                {
                    shopify.updateItemToCart(variantId, oldQuantity + quantity)
                }
            })
        },

        hideNum()
        {
            this.addHidden = false
        },

        showNum()
        {
            this.addHidden = true
        },

        updateNum(cart)
        {
            const item = cart.list.find(({ slug }) => slug === this.product.slug)
            if (item)
            {
                this.num = item.quantity
            }
            else
            {
                this.num = 0
            }
        }
    }
}